import React from "react";

export interface HardwareBackContextValue {
    state: {
        shouldHandle: boolean;
        activeRoute?: string;
    };
    setState: (state: HardwareBackContextValue["state"]) => void;
}

export const HardwareBackContext = React.createContext<HardwareBackContextValue>({
    state: {
        shouldHandle: false,
    },
    setState: () => void 0,
});

if (__DEV__) {
    HardwareBackContext.displayName = "HardwareBackContext";
}
